<template>
  <div class="c-movie__desc__col" v-if="movieDetail">
    <h3 class="c-movie__title">{{movieDetail.Title | titleCase}}</h3>
    <div class="c-movie__info">
      <p class="c-movie__info__items c-movie__info--rate">{{movieDetail.Rating}}</p>
      <p class="c-movie__info__items c-movie__info--time">{{time}}</p>
      <p class="c-movie__info__items c-movie__info--trailer" v-if="showTrailer && movieDetail.TrailerUrl">
        <svg width="8" height="10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M.5 9.263V.737L6.682 5 .5 9.263z" stroke="#444" />
        </svg>

        <silentbox-single :autoplay="true" :src="movieDetail.TrailerUrl || 'https://www.youtube.com/watch?v=wmiIUN-7qhE'" :description="movieDetail.name">
          trailer
        </silentbox-single>
      </p>
    </div>
    <div class="c-movie__description" v-html="movieDetail.Description">
      {{movieDetail.Description || defaultDesc}}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'movie-info',
    props: {
      movieDetail: Object,
      showTrailer: Boolean
    },
    data() {
      return {
        defaultDesc: '',
      }
    },
    computed: {
      lastStep() {
        return this.steps[this.steps.length - 1];
      },
      list() {
        return this.steps.slice(0, this.steps.length - 1)
      },
      time() {
        const num = this.movieDetail.Length;
        const hours = Math.floor(num / 60);
        const minutes = num % 60;
        return `${hours}hr ${minutes}min`;
      }
    }
  };
</script>
